<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ file ? 'Update' : 'Add' }} Folder
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Folder Name">
          <d-input v-model="form.name" />
        </d-field>
        <d-field label="Description">
          <l-html-editor v-model="form.description" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$emit('close')">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ file ? 'Update' : 'Add' }} Folder
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import { createItem, updateItem } from '@resources/scripts/services/contentListingItemsApi.service';
  import { ListingItemType } from '@resources/scripts/constants';
  import { showErrorToast } from '@services/errorHandling.service';

  export default {
    props: {
      contentListing: {
        type: Object,
        default: () => ({}),
      },
      file: {
        type: Object,
        default: null,
      },
    },

    emits: ['close', 'saved'],

    data() {
      return {
        saving: false,
        form: {
          name: '',
          description: '',
          categorized: true,
          type: ListingItemType.FOLDER,
        },
      };
    },

    mounted() {
      if (this.file) {
        this.form = JSON.parse(JSON.stringify(this.file));
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.file) {
            await updateItem(this.form.id, this.form, this.contentListing.type);
          } else {
            await createItem(this.form, this.contentListing.id, this.contentListing.type);
          }
          this.$emit('saved');
          this.$emit('close');
        } catch (error) {
          showErrorToast(error);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>